// extracted by mini-css-extract-plugin
module.exports = {"content":"BalanceConsumption_content__2Uivh","rowFlex":"BalanceConsumption_rowFlex__2S1ie"};